import React from 'react';
import { ClipboardCheck, MapPin, ChevronRight } from 'lucide-react';
import { formatDateLabel, hasAttendance, openOutFor, todayISO, tileStatus } from '../../lib/ihsanRollStore';
import { GlanceLine } from './shared';

export default function ResidentView({ store, caseNo, onAttendance, onMovement, onStatus }) {
  const status = tileStatus(store, caseNo);
  const open = openOutFor(store, caseNo);
  const logged = hasAttendance(store, caseNo);
  const glance =
    status === 'overdue'
      ? `Out overdue${open?.place ? ` — ${open.place}` : ''}`
      : status === 'out'
        ? `Currently out${open?.place ? ` — ${open.place}` : ''}`
        : logged
          ? 'In · attendance logged today'
          : 'In · attendance not yet logged';

  return (
    <div className="px-4 pt-5 pb-8" data-testid="ihsanroll-resident">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        {formatDateLabel(todayISO())}
      </p>
      <h1 className="text-2xl font-extrabold text-[#0F172A] mt-1">Case #{caseNo}</h1>
      <GlanceLine>{glance}</GlanceLine>

      <div className="mt-6 flex flex-col gap-3">
        <button
          type="button"
          data-testid="ihsanroll-log-attendance"
          onClick={onAttendance}
          className="min-h-[72px] rounded-2xl border border-border bg-white px-4 flex items-center gap-3 text-left hover:bg-muted/30"
        >
          <span className="h-11 w-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
            <ClipboardCheck className="h-5 w-5 text-primary" />
          </span>
          <span className="flex-1">
            <span className="block text-sm font-bold text-[#0F172A]">Log Attendance</span>
            <span className="block text-xs text-muted-foreground">Today&apos;s programme checklist</span>
          </span>
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
        </button>

        <button
          type="button"
          data-testid="ihsanroll-log-movement"
          onClick={onMovement}
          className="min-h-[72px] rounded-2xl border border-border bg-white px-4 flex items-center gap-3 text-left hover:bg-muted/30"
        >
          <span className="h-11 w-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
            <MapPin className="h-5 w-5 text-primary" />
          </span>
          <span className="flex-1">
            <span className="block text-sm font-bold text-[#0F172A]">Log Movement</span>
            <span className="block text-xs text-muted-foreground">Going out or reaching back</span>
          </span>
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
        </button>
      </div>

      <button
        type="button"
        data-testid="ihsanroll-view-status"
        onClick={onStatus}
        className="mt-4 text-sm font-semibold text-primary"
      >
        View status
      </button>
    </div>
  );
}
